import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.9996 2.46143C23.4766 2.46143 29.5385 8.5226 29.5387 15.9995C29.5387 23.4766 23.4767 29.5386 15.9996 29.5386C8.52271 29.5384 2.46153 23.4765 2.46153 15.9995C2.46174 8.52272 8.52283 2.46163 15.9996 2.46143ZM15.9996 4.92334C9.8823 4.92354 4.92365 9.88219 4.92345 15.9995C4.92345 22.117 9.88218 27.0765 15.9996 27.0767C22.1172 27.0767 27.0768 22.1171 27.0768 15.9995C27.0766 9.88207 22.1171 4.92334 15.9996 4.92334ZM19.4811 10.7778C19.9616 10.2978 20.7408 10.2977 21.2213 10.7778C21.7018 11.2584 21.7016 12.0384 21.2213 12.519L17.7399 15.9995L21.2213 19.481C21.7018 19.9615 21.7015 20.7405 21.2213 21.2212C20.7407 21.7018 19.9617 21.7018 19.4811 21.2212L15.9996 17.7397L12.5191 21.2212C12.0385 21.7018 11.2586 21.7018 10.7779 21.2212C10.2977 20.7406 10.2976 19.9615 10.7779 19.481L14.2584 15.9995L10.7779 12.519C10.2973 12.0384 10.2973 11.2585 10.7779 10.7778C11.2585 10.2977 12.0376 10.2976 12.5182 10.7778L15.9996 14.2593L19.4811 10.7778Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }